export const errorTypes = {
    VALIDATIONS : 'VALIDATIONS'
}